const news = [
    {
        id:null,
        title:"Jordan Bowers X Honda Sports Finalist",
        desc:"Jordan Bowers was named one of the four finalists for the 2024 Honda Sports Award",
        image:process.env.PUBLIC_URL + '/news/news11.png',
        link:'https://www.oudaily.com/sports/ou-womens-gymnastics-2024-honda-sports-award-for-gymnastics-jordan-bowers-finalist/article_fa5134fe-01b1-11ef-9a2b-873e05ef7f95.html',
    },
    {
        id:null,
        title:"Lionettes Make History",
        desc:"Nikki Romano and the Lionettes place third at UDA Nationals",
        image:process.env.PUBLIC_URL + '/news/news12.png',
        link:'https://onwardstate.com/2024/01/17/penn-state-lionettes-place-third-at-national-competition/',
    },
    {
        id:null,
        title:"Veronica Zelner X Valley Mag",
        desc:"Veronica provides a glimpse into her life and personality",
        image:process.env.PUBLIC_URL + '/news/news16.png',
        link:'http://www.valleymagazinepsu.com/spring-2024-cover-story-mirrored-metamorphosis/',
    },
    {
        id:null,
        title:"Jordan Bowers X OU Daily",
        desc:"Jordan Bowers has overcome obstacles to become OU gymnastics' leader",
        image: process.env.PUBLIC_URL + '/news/news8.png',
        link:'https://www.oudaily.com/sports/shes-irreplaceable-to-this-team-jordan-bowers-has-overcome-obstacles-to-become-ou-gymnastics-leader/article_17db3332-cec1-11ed-9b97-07687dd3dd21.html',
    },
    {
        id:null,
        title:"LSU Women Gymnastics Writes History",
        desc:"Annie Beard and the LSU Tigers win first every NCAA gynmastics championship",
        image:process.env.PUBLIC_URL + '/news/news15.png',
        link:'https://justwomenssports.com/reads/lsu-wins-first-ncaa-gymnastics-champtionship/', // need photo
    },
    {
        id:null,
        title:"Jordan Bowers X Sports Illustrated",
        desc:"Jordan Bowers Perfect 10 earned her another NCAA regional title",
        image: process.env.PUBLIC_URL + '/news/news6.png',
        link:'https://www.si.com/college/oklahoma/football/ou-gymnastics-two-perfect-10s-highlight-oklahomas-romp-into-saturday',
    },
    {
        id:null,
        title:"Juan Faura X Elevation Nation Podcast",
        desc:"A constant desire to elevate | Student Entrepreneur Juan Faura",
        image:process.env.PUBLIC_URL + '/news/news3.png',
        link:'https://open.spotify.com/episode/2EbPVC488ZfPlTGVDM5euh',
    },
    {
        id:null,
        title:"Sophia Gladieux X Yahoo Sports",
        desc:"Sophia Gladieux invited to play with U.S. Women's National Team",
        image:process.env.PUBLIC_URL + '/news/news2.png',
        link:'https://sports.yahoo.com/oley-valley-grad-sophia-gladieux-045000483.html'
    },
    {
        id:null,
        title:"CJ Kirker X Digital Test Lab",
        desc:"Happy Valley LaunchBox hosts Digital Testlab for Content Creators",
        image:process.env.PUBLIC_URL + '/news/news14.png',
        link:'https://www.psu.edu/news/invent-penn-state/story/six-entrepreneurs-participate-first-content-creator-accelerator/',
    },
    {
        id:null,
        title:"Shay Ciezki X Daily Collegian",
        desc:"Shay Ciezki has record-setting performance for Penn State women's basketball",
        image: process.env.PUBLIC_URL + '/news/news5.png',
        link:'https://www.psucollegian.com/sports/women_basketball/shay-ciezki-has-record-setting-performance-for-penn-state-womens-basketball/article_e57f98a4-9f69-11ee-9dd4-7ff97cd56c75.html',
    },
    {
        id:null,
        title:"Sophia Gladieux X Onward State",
        desc:"Penn State Field Hockey's Sophia Gladieux Exploring New Avenues In NIL With Student Collaboration",
        image:process.env.PUBLIC_URL + '/news/news7.png',
        link:'https://onwardstate.com/2023/03/21/penn-state-field-hockeys-sophia-gladieux-exploring-new-avenues-in-nil-with-student-collaboration/',
    },
    {
        id:null,
        title:"Juan Faura X PSN News",
        desc:"Juan talking about his experience in athlete/influencer marketing",
        image: process.env.PUBLIC_URL + '/news/news10.png',
        link:'https://www.youtube.com/watch?v=lFXJn-bU2gQ',
    },
    {
        id:null,
        title:"Veronica Zelner X Daily Collegian",
        desc:"This is only the beginning for Veronica | Meet student bodybuilder Veronica Zelner",
        image: process.env.PUBLIC_URL + '/news/news9.png',
        link:'https://www.psucollegian.com/news/this-is-only-the-beginning-for-veronica-meet-student-bodybuilder-veronica-zelner/article_b1ee2ce2-ad95-11ed-914c-33d7ce3d01c0.html',
    },


]

export default news;